import { mapGetters } from 'vuex';
import PremiumModal from '@/components/common/PremiumModal';

export default {
  computed : {
    ...mapGetters({
      subscription : 'subscription/subscription',
      user         : 'user/user',
    }),
  },
  methods : {

    /**
     * Check Content
     * @param data
     */
    checkContent(data, contentType) {
      if (data.isFree === 1 || data.is_free === 1)
        this.$router.push(data.link);
      else {
        if (this.user.user_type === 1 ||
          this.subscription.classname === 'free')
          this.showPremiumModal(contentType);
        else if (data.link) 
          this.$router.push(data.link);
        else
          this.$router.push(`/media/${data.media_id}/${data.wistia_id}`)
      }
    },

    /**
     * Show Premium Modal
     * @param contentType
     */
    showPremiumModal(contentType) {
      this.$modal.show(PremiumModal, {
        contentType : contentType,
        userType    : this.user.user_type,
      }, {
        height   : 'auto',
        adaptive : true,
        classes  : 'premium-modal',
      });
    },
  },
}